import CaspianXxApiQueryItem from '../../../Domain/CaspianXxApiQueryItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CaspianXXApiQueryService from '../../../Services/CaspianXXApiQueryService';

// Drives the GeneralEditWizzardBaseFigma edit wizard for CaspianXx API queries.
// A single page with <=6 fields renders as the compact centered DS modal.
export default class CaspianXxApiQueryWindowDescription {
  static titleForCreate = 'Add New CaspianXx Api Query';
  static titleForEdit = 'Edit CaspianXx Api Query';
  static entityName = 'CaspianXx Api Query';
  static idField = 'CaspianXextraApiQueryId';
  static nameField = 'TargetType';
  static itemType = CaspianXxApiQueryItem;
  static serviceFunction = CaspianXXApiQueryService.Edit;
  static messageOnSuccess = 'CaspianXx Api Query has been saved.';
  static finishButtonLabel = 'Save CaspianXx Api Query';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Frequency',
          label: 'Frequency',
          className: 'col-6',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.forRequiredTextField,
          selectvalues: () => CaspianXxApiQueryWindowDescription.getFrequencySelectValues(),
        },
        {
          fieldName: 'IsActive',
          label: 'IsActive',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'StartDate',
          label: 'StartDate',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'EndDate',
          label: 'EndDate',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];

  static getFrequencySelectValues() {
    return selectHelper.generateSelectValues(['', 'Daily', 'Twice-a-week', 'Weekly', 'Fortnightly', 'Monthly', 'On-Demand']);
  }
}
